import { DragScroll, Layout, LoadingSpinner } from "../../components";
import { DashboardController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { Footer } from "../../layout/footer";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { BsList } from "react-icons/bs";
import {
  FaChartLine,
  FaCheckCircle,
  FaEye,
  FaRegCalendarAlt,
  FaUsers,
} from "react-icons/fa";

const CHART_OPTIONS: any = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "#0c1a58",
      titleColor: "#ffffff",
      bodyColor: "#ffffff",
      padding: 12,
      cornerRadius: 8,
      titleFont: { family: "Peyda", size: 13 },
      bodyFont: { family: "Peyda", size: 12 },
      boxPadding: 4,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: "#525151",
        font: { family: "Peyda", size: 12 },
      },
    },
    y: {
      beginAtZero: true,
      grid: { color: "rgba(12, 26, 88, 0.06)" },
      ticks: {
        color: "#525151",
        font: { family: "Peyda", size: 12 },
      },
    },
  },
};

const LEGEND = [
  { label: "تیکت‌های دیده‌شده", color: "#009595", cls: "teal" },
  { label: "تاریخ پایان بیمه‌نامه", color: "#ca9602", cls: "yellow" },
  { label: "اطلاعات تکمیل‌شده", color: "#f45632", cls: "red" },
];

class Dashboard extends DashboardController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getDashboardData();
  }
  render() {
    const {
      dashboardData,
      chartLoading,
      endData,
      loading,
      selectedItem,
      seenData,
      phoneData,
      persianData,
    } = this.state;

    const datasets = [
      {
        label: "تیکت‌های دیده‌شده",
        data: seenData,
        borderColor: "#009595",
        backgroundColor: "rgba(0, 149, 149, 0.12)",
        fill: true,
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#009595",
      },
      {
        label: "تاریخ پایان بیمه‌نامه",
        data: endData,
        borderColor: "#ca9602",
        backgroundColor: "rgba(202, 150, 2, 0.12)",
        fill: true,
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#ca9602",
      },
      {
        label: "اطلاعات تکمیل‌شده",
        data: phoneData,
        borderColor: "#f45632",
        backgroundColor: "rgba(244, 86, 50, 0.12)",
        fill: true,
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#f45632",
      },
    ];

    const singleUser = dashboardData?.length === 1 ? dashboardData[0] : null;

    return (
      <Layout title="داشبورد">
        <Helmet>
          <title> داشبورد | سامانه مشتریان</title>
        </Helmet>
        <div className="dashboard">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className="dashboard-header">
                <div className="dashboard-header-title">
                  <BsList color="#003366" className="ms-2" />
                  <span>داشبورد</span>
                </div>
                <span className="dashboard-header-sub">
                  نمای کلی فعالیت همکاران
                </span>
              </div>

              {singleUser ? (
                <div className="dashboard-stats">
                  <div className="dashboard-stat dashboard-stat--teal">
                    <span className="dashboard-stat-icon">
                      <FaEye />
                    </span>
                    <span className="dashboard-stat-label">
                      تیکت‌های دیده‌شده
                    </span>
                    <span className="dashboard-stat-value">
                      {singleUser?.today?.seen ?? "—"}
                    </span>
                  </div>
                  <div className="dashboard-stat dashboard-stat--yellow">
                    <span className="dashboard-stat-icon">
                      <FaRegCalendarAlt />
                    </span>
                    <span className="dashboard-stat-label">
                      تاریخ پایان بیمه‌نامه
                    </span>
                    <span className="dashboard-stat-value">
                      {singleUser?.today?.end_date ?? "—"}
                    </span>
                  </div>
                  <div className="dashboard-stat dashboard-stat--red">
                    <span className="dashboard-stat-icon">
                      <FaCheckCircle />
                    </span>
                    <span className="dashboard-stat-label">
                      اطلاعات تکمیل‌شده
                    </span>
                    <span className="dashboard-stat-value">
                      {singleUser?.today?.phone_data ?? "—"}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="dashboard-users">
                  <div className="dashboard-users-head">
                    <span className="dashboard-head-icon">
                      <FaUsers />
                    </span>
                    <span className="dashboard-users-head-title">
                      همکاران
                    </span>
                  </div>
                  <DragScroll className="dashboard-users-grid">
                    {dashboardData?.length > 0 &&
                      dashboardData?.map((item: any, index: number) => {
                        const active =
                          selectedItem?.user_name === item?.user_name;
                        return (
                          <button
                            type="button"
                            key={index}
                            className={`dashboard-user-card${
                              active ? " is-active" : ""
                            }`}
                            onClick={() => this.handleChartData(item)}
                          >
                            <span className="dashboard-user-avatar">
                              {item?.name?.charAt(0) || "؟"}
                            </span>
                            <span className="dashboard-user-name">
                              {item?.name}
                            </span>
                            <div className="dashboard-user-stats">
                              <div className="dashboard-user-stat dashboard-user-stat--teal">
                                <span className="stat-dot stat-dot--teal" />
                                <span className="stat-label">
                                  تیکت‌های دیده‌شده
                                </span>
                                <span className="stat-value">
                                  {item?.today?.seen ?? "—"}
                                </span>
                              </div>
                              <div className="dashboard-user-stat dashboard-user-stat--yellow">
                                <span className="stat-dot stat-dot--yellow" />
                                <span className="stat-label">
                                  پایان بیمه‌نامه
                                </span>
                                <span className="stat-value">
                                  {item?.today?.end_date ?? "—"}
                                </span>
                              </div>
                              <div className="dashboard-user-stat dashboard-user-stat--red">
                                <span className="stat-dot stat-dot--red" />
                                <span className="stat-label">
                                  اطلاعات تکمیل‌شده
                                </span>
                                <span className="stat-value">
                                  {item?.today?.phone_data ?? "—"}
                                </span>
                              </div>
                            </div>
                            <span className="dashboard-user-btn">
                              <FaChartLine />
                              نمایش نمودار
                            </span>
                          </button>
                        );
                      })}
                  </DragScroll>
                </div>
              )}

              <div className="dashboard-chart">
                <div className="dashboard-chart-head">
                  <div className="dashboard-chart-title">
                    <h2>
                      <span className="dashboard-head-icon">
                        <FaChartLine />
                      </span>
                      نمودار فعالیت
                    </h2>
                  </div>
                </div>
                <div className="dashboard-chart-legend">
                  {LEGEND.map((item) => (
                    <span
                      key={item.label}
                      className={`legend-item legend-item--${item.cls}`}
                    >
                      {item.label}
                    </span>
                  ))}
                </div>
                <div className="dashboard-chart-body">
                  {chartLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <Line
                      data={{ labels: persianData, datasets }}
                      options={CHART_OPTIONS}
                    />
                  )}
                </div>
              </div>
            </>
          )}
          <Footer />
        </div>
      </Layout>
    );
  }
}

export default Dashboard;
